module.exports = __webpack_public_path__ + "img/openinigConnection.c6ce33b8.svg";